import React from 'react';
import { HTMLAttributes } from 'react';
import { PictoName, pictosLibrary } from './pictosLibrary';
import { classNames } from '../../utils/style';

interface Props {
  name: PictoName;
  className?: string;
  style?: HTMLAttributes<'svg'>['style'];
  width?: number;
  height?: number;
}
export const PictoComponent = ({
  name,
  className,
  style,
  width,
  height,
}: Props) => {
  const _name = pictosLibrary.find((picto) => picto === name) ? name : 'empty';

  return (
    <svg
      className={classNames(className)}
      fill="currentColor"
      style={style}
      width={width}
      height={height}
    >
      <use href={`/icons/pictos.svg#${_name}`} width="100%" height="100%"></use>
    </svg>
  );
};
